import { cn } from "@/utils/cn";

interface ModalHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  className,
  children,
}) => {
  if (title) {
    return (
      <h1
        className={cn(
          "px-20 py-8 text-[1.8rem] lg:text-[2.1rem] leading-snug font-bold text-center",
          className,
        )}
      >
        {title}
      </h1>
    );
  }
  return <div className={cn("px-20 py-8", className)}>{children}</div>;
};
